import * as React from 'react';

const ThumbStripes = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={11} height={15} {...props}>
        <defs>
            <filter
                id="thumbstripes_a"
                width="1077.8%"
                height="1077.8%"
                x="-488.9%"
                y="-400%"
                filterUnits="objectBoundingBox"
            >
                <feOffset dy={24} in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation={40} />
                <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                <feColorMatrix
                    in="shadowBlurOuter1"
                    result="shadowMatrixOuter1"
                    values="0 0 0 0 0.229949 0 0 0 0 0.461254 0 0 0 0 0.626472 0 0 0 0.053333 0"
                />
                <feOffset dy={16} in="SourceAlpha" result="shadowOffsetOuter2" />
                <feGaussianBlur in="shadowOffsetOuter2" result="shadowBlurOuter2" stdDeviation={12} />
                <feComposite in="shadowBlurOuter2" in2="SourceAlpha" operator="out" result="shadowBlurOuter2" />
                <feColorMatrix
                    in="shadowBlurOuter2"
                    result="shadowMatrixOuter2"
                    values="0 0 0 0 0.231373 0 0 0 0 0.462745 0 0 0 0 0.627451 0 0 0 0.026667 0"
                />
                <feMerge>
                    <feMergeNode in="shadowMatrixOuter1" />
                    <feMergeNode in="shadowMatrixOuter2" />
                </feMerge>
            </filter>
            <circle id="thumbstripes_b" cx={13.5} cy={13.5} r={13.5} />
        </defs>
        <g fill="none" fillRule="evenodd">
            <path d="M-233 4H16v7h-249z" />
            <g transform="translate(-8 -6)">
                <use xlinkHref="#thumbstripes_b" fill="currentColor" filter="url(#thumbstripes_a)" />
                <circle cx={13.5} cy={13.5} r={13} fill="#FFF" stroke="currentColor" strokeLinejoin="miter" />
            </g>
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M9.5 13.5v-12m-4 12v-12m-4 12v-12"
            />
        </g>
    </svg>
);
export default ThumbStripes;
